export default __webpack_public_path__ + "static/media/OnduladaTosca.88069ce6.jpg";